export default function PHP_elseif() {
  return (
    <div>
      <h1>PHP_elseif</h1>
    </div>
  );
}
